import React, { useEffect, useState } from "react";
import { Form, Card, Spinner, Button } from "react-bootstrap";
import { AiOutlineCloudUpload, AiOutlineFilePdf } from "react-icons/ai";
import { FaRegImage } from "react-icons/fa";
import api from "../../utils/api";
import Swal from "sweetalert2";
import socket from "../../context/socket";

const UploadNomineeDocument = ({ onFileSelect, roomId,fileUrl, setFileUrl,nomineeOptModalData }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadedData, setUploadedData] = useState(null);
  console.log('fileUrl', fileUrl,nomineeOptModalData);




  const handleFileChange = async (e) => {
    const selected = e.target.files[0];
    if (!selected) return;

    setFile(selected);
    await uploadToServer(selected, roomId);
  };

  /** ⬇ Upload File + client_id to API */
  const uploadToServer = async (file, clientId) => {
    try {
      setUploading(true);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("client_id", clientId);
      formData.append("ref_number", nomineeOptModalData?.relationship);
      formData.append("otp", 123456);
      formData.append("client_code", nomineeOptModalData?.clientCode);

      const response = await api.post(
        "advisor/create-nominee-reference",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      console.log("Upload Response:", response.data?.data);
      const url = response.data?.data?.file_path || null;

      setFileUrl(url);

      setUploadedData(response?.data);
      setUploading(false);

      Swal.fire({
        icon: "success",
        title: "Uploaded!",
        text: "Document uploaded successfully.",
        confirmButtonColor: "#4caf50",
        timer: 1800,
      });

      // 🔥 Emit through socket (your requirement)
      // socket.emit("nominee_declaration", {
      //   room: roomId,
      //   data: {
      //     // fileName: file.name,
      //     fileUrl: url,
      //     // client_id: clientId,
      //     // response: response?.data
      //   }
      // });

      // onFileSelect({
      //   file,
      //   client_id: clientId,
      //   response: response?.data,
      // });

    } catch (err) {
      setUploading(false);
      console.error("Upload Error:", err);

      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: "Could not upload document. Please try again.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const getFileIcon = () =>
    file?.type === "application/pdf" ? (
      <AiOutlineFilePdf size={22} className="me-2 text-danger" />
    ) : (
      <FaRegImage size={22} className="me-2 text-primary" />
    );

  const openDocument = () => {
    if (!fileUrl) {
      Swal.fire({
        icon: "warning",
        title: "No File URL",
        text: "Uploaded file URL missing from server.",
      });
      return;
    }
    window.open(fileUrl, "_blank");
  };

  return (
    <div className="upload-container">
      <p className="fw-semibold my-2">Upload Declaration Document</p>

      <Card
        className="p-4 text-center upload-card shadow-sm w-100"
        style={{
          border: "2px dashed #a5c3ff",
          cursor: "pointer",
          background: "#f8fbff",
        }}
      >
        <label
          htmlFor="nominee-upload"
          className="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
          style={{ cursor: "pointer" }}
        >
          <AiOutlineCloudUpload size={35} color="#4a7aff" />

          {uploading ? (
            <p className="mt-2 text-primary fw-bold">
              <Spinner size="sm" animation="border" /> Uploading...
            </p>
          ) : (
            <p className="mt-2 text-secondary mb-0">
              Click to upload PDF / JPG / PNG
            </p>
          )}
        </label>

        {/* Hidden Input */}
        <Form.Control
          id="nominee-upload"
          type="file"
          className="d-none"
          accept=".pdf,.jpg,.jpeg,.png"
          onChange={handleFileChange}
        />
      </Card>

      {/* File Preview */}
      {/* {file && (
        <div
          className="p-2 px-3 mt-3 rounded d-flex align-items-center shadow-sm w-100"
          style={{ background: "#e8f0ff" }}
        >
          {getFileIcon()}
          <span className="fw-semibold">{file.name}</span>
        </div>
      )} */}
      {/* File Preview + View Button */}
      {/* === Show NEWLY selected file === */}
      {file && (
        <div
          className="p-2 px-3 mt-3 rounded d-flex align-items-center justify-content-between shadow-sm w-100"
          style={{ background: "#e8f0ff" }}
        >
          <div className="d-flex align-items-center">
            {getFileIcon()}
            <span className="fw-semibold">{file.name}</span>
          </div>

          {fileUrl && (
            <Button
              variant="primary"
              size="sm"
              className="px-3"
              onClick={openDocument}
            >
              View
            </Button>
          )}
        </div>
      )}

      {/* === Show EXISTING file when no new file selected === */}
      {!file && fileUrl && (
        <div
          className="p-2 px-3 mt-3 rounded d-flex align-items-center justify-content-between shadow-sm w-100"
          style={{ background: "#e8f0ff" }}
        >
          <div className="d-flex align-items-center">
            <AiOutlineFilePdf size={22} className="me-2 text-danger" />
            <span className="fw-semibold">Existing uploaded document</span>
          </div>

          <Button
            variant="primary"
            size="sm"
            className="px-3"
            onClick={openDocument}
          >
            View
          </Button>
        </div>
      )}


    </div>
  );
};

export default UploadNomineeDocument;
